// You can write your custom Javascript here
jQuery.fn.bindFirst = function(name, fn) {
  var elem, handlers, i, _len;
  this.bind(name, fn);
  for (i = 0, _len = this.length; i < _len; i++) {
    elem = this[i];
    handlers = jQuery._data(elem).events[name.split('.')[0]];
    handlers.unshift(handlers.pop());
  }
};

//jQuery(document).on('click', '.js-show-instant-price-actions', function() {
jQuery(".js-show-instant-price-actions").bindFirst("click", function() {	
  	var checkWidth = jQuery("form.product__form #field-min-width").val();
  	var checkDrop = jQuery("form.product__form #field-min-drop").val();
  	
  	if(checkWidth == "" || checkDrop == "") {
  		if (checkWidth == "") {
  			console.log("checkWidth");
  			jQuery("form.product__form .product__measurements .list-fields li:first-child").addClass('has-hint');
  			jQuery("form.product__form .product__measurements .list-fields li:first-child .field").addClass('show-hint-min');
  		}

  		if (checkDrop == "") {
  			console.log("checkDrop");
  			jQuery("form.product__form .product__measurements .list-fields li:last-child").addClass('has-hint');
  			jQuery("form.product__form .product__measurements .list-fields li:last-child .field").addClass('show-hint-min');
  		}

  		jQuery('html, body').animate({
  			scrollTop: jQuery("form.product__form .product__measurements .list-fields").offset().top
  		}, 500);

  		return false;
  	}
});


// Implement content slider for Installation. Load custom drawer if option is available
if (jQuery('.has-tooltip-insurance').length){
    customDrawer("tooltip-insurance");
};


// Implement content slider for Installation. Load custom drawer if option is available
if (jQuery('body').hasClass('template-product') && jQuery('.has-tooltip-installation').length){
    customDrawer("tooltip-installation");
};

// Implement content slider for Heading. Load custom drawer if option is available
if (jQuery('body').hasClass('template-product') && jQuery('.has-tooltip-heading').length){
    customDrawer("tooltip-heading");
};

// Implement content slider for Eyelet. Load custom drawer if option is available
if (jQuery('body').hasClass('template-product') && jQuery('.has-tooltip-eyelet').length){
    customDrawer("tooltip-eyelet");
};

// Implement content slider for Lining. Load custom drawer if option is available
if (jQuery('body').hasClass('template-product') && jQuery('.has-tooltip-lining').length){
    customDrawer("tooltip-lining");
};

// Implement content slider for Pair / Single. Load custom drawer if option is available
if (jQuery('body').hasClass('template-product') && jQuery('.has-tooltip-pair-single').length){
    customDrawer("tooltip-pair-single");
}

// Implement content slider for NDD. Load custom drawer if NDD is available
if (jQuery('body').hasClass('template-product') && jQuery('.has-tooltip-ndd').length){
  customDrawer("tooltip-ndd");
};

if (jQuery('body').hasClass('template-product') && jQuery('.product-velux').length){
  customDrawer("velux-drawer");
};

// Implement content slider for Exact & Recess. Load custom drawer if Fitting option is available
if (jQuery('body').hasClass('template-product') && jQuery('.tooltip-drawer').length){
    customDrawer("tooltip-drawer");
};

// Implement content slider for control type option. Load custom drawer if option is available
if (jQuery('body').hasClass('template-product') && jQuery('.has-tooltip-control-type').length){
  customDrawer("tooltip-control-type");
};

// Implement content slider for Slat Size option. Load custom drawer if option is available
if (jQuery('body').hasClass('template-product') && jQuery('.has-tooltip-slatsize').length){
  customDrawer("tooltip-slatsize");
};

// Implement content slider for Cord Type option. Load custom drawer if option is available
if (jQuery('body').hasClass('template-product') && jQuery('.has-tooltip-cordtype').length){
  customDrawer("tooltip-cordtype");
};

if (jQuery('body').hasClass('template-product') && jQuery('.has-tooltip-curtainlining').length){
  customDrawer("tooltip-curtainlining");
};

if (jQuery('body').hasClass('template-product') && jQuery('.has-tooltip-bottom-bar').length){
  customDrawer("tooltip-bottom-bar");
};

// Implement content slider for Bunch option. Load custom drawer if option is available
if (jQuery('body').hasClass('template-product') && jQuery('.has-tooltip-bunch').length){
  customDrawer("tooltip-bunch");
};

// Implement content slider for Custom Lining. Load custom drawer if option is available
if (jQuery('body').hasClass('template-product') && jQuery('.has-tooltip-lining-custom').length){
  customDrawer("tooltip-lining-custom");
};

// Implement content slider for Custom Fitting Option on roller blinds. Load custom drawer if option is available
if (jQuery('body').hasClass('template-product') && jQuery('.has-tooltip-fitting-custom').length){
  customDrawer("tooltip-fitting-custom");
};
if (jQuery('body').hasClass('template-product') && jQuery('.has-tooltip-veluxframe').length){
  customDrawer("tooltip-veluxframe");
};

// Implement content slider for Perfect Fit option. Load custom drawer if option is available
if (jQuery('body').hasClass('template-product') && jQuery('.has-tooltip-perfect-fit-bracket').length){
  customDrawer("tooltip-perfect-fit-bracket"); 
};

// Implement content slider for Chain Type option. Load custom drawer if option is available
 if (jQuery('body').hasClass('template-product') && jQuery('.has-tooltip-chain-type').length){
   customDrawer("tooltip-chain-type"); 
 };

// Implement Eyelet option panel trigger by click on heading with option eyelet
if (jQuery('body').hasClass('template-product') 
  && jQuery('.form__controls.form-type-heading').length
  && jQuery('.form__controls.form-type-eyelet').length){
  jQuery(document).on('click', '[data-props-label="Pencil Pleat"]', function(e){
    jQuery('.form__controls.form-type-eyelet').removeClass('is-visible');
  });
  jQuery(document).on('click', '[data-props-label="Eyelet"]', function(e){
    //console.log("Eyelet clicked");
    jQuery('.form__controls.form-type-eyelet').addClass('is-visible');
  });
};

function customDrawer(element) {
  console.log("%c Loaded drawer ", "border-radius:5px; background: blue; color: white");
  //Open
  jQuery(document).on('click', '[data-action="open-drawer"][data-drawer-id="' + element + '"]', function(e){
    e.preventDefault();

    customDrawerOpen(element);
  });

  //Close
  jQuery('#' + element).on('click', '[data-action="close-drawer"][data-drawer-id="' + element + '"]', function(e){
    e.preventDefault();
    jQuery('#' + element).attr("aria-hidden","true");
    jQuery('.modal-overlay[data-drawer-id="' + element + '"]').toggleClass('is-visible');
    jQuery('body').toggleClass('no-scroll');
  });

  //Close overlay
  jQuery(document).on('click', '.modal-overlay[data-drawer-id="' + element + '"]', function(e){
    e.preventDefault();
    jQuery('#' + element).attr("aria-hidden","true");
    jQuery(this).toggleClass('is-visible');
    jQuery('body').toggleClass('no-scroll');
  });
}

function customDrawerOpen(element) {
  if(jQuery('#' +element).length) {
    jQuery('#' + element).attr("aria-hidden","false");
    jQuery('.modal-overlay[data-drawer-id="' + element + '"]').toggleClass('is-visible');
    jQuery('body').toggleClass('no-scroll');
  }
}

jQuery( document ).on( 'change', 'input[name="data[Fitting]"]', function(){ 
  let fieldValue = jQuery( this ).val();

  // Display select measure options when required
  if( fieldValue == 'Exact|selectmeasure' ) {
    jQuery( '.form-type-selectmeasure' ).show();
  } else {
    jQuery( '.form-type-selectmeasure' ).hide();
  }
});

jQuery(document).on('input', '.js-curtainlining-link', function() {
  const $this = jQuery(this);
  const url = $this.data('url');

  window.open(window.location.origin + url, '_self');
});
jQuery(document).on('input', '.js-veluxframe-link', function() {
  const $this = jQuery(this);
  const url = $this.data('url');
  window.open(window.location.origin + url, '_self');
});
